export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9541.188bf02a.jpg";